// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_Epm","cls2":"FeedbackPopover-cls2_5kt FeedbackPopover-cls1_Epm"};